import React from "react";
import { Box } from "@mui/material";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import { APP_TOKENS, dependentGroupStyles } from "./publicFormTokens";

/**
 * A cluster of follow-up questions that only exist because of the answer
 * directly above them — indented behind a brand rule so the dependency reads at
 * a glance rather than looking like a peer question.
 *
 * Spans the full width of its parent FormGrid: these groups always follow the
 * question that reveals them, and half-width would orphan them beside an
 * unrelated field.
 */
const DependentGroup = ({ label, children }) => (
  <Box sx={{ gridColumn: "1 / -1", minWidth: 0 }}>
    <Flx column gap={1.5} sx={dependentGroupStyles}>
      {label && (
        <Txt
          component="div"
          sx={{ fontWeight: 600, fontSize: 14, color: APP_TOKENS.inkMuted }}
        >
          {label}
        </Txt>
      )}
      {children}
    </Flx>
  </Box>
);

export default DependentGroup;
